<template>
  <div>
    <!-- <van-button size="large" icon="service-o" v-if="enableBell()" @click="cmdServiceType"> -->
    <van-button
      size="large"
      icon="friends-o"
      @click="show"
      :round="gBtnRound()"
      v-if="isEatIn()"
    >
      客數 {{ qty1 }} 位
    </van-button>

    <van-popup
      v-model="visible"
      class="HideScrollbar"
      :close-on-click-overlay="false"
      :style="{ width: '360px', height: '320px' }"
    >
      <van-nav-bar title="來客數" fixed placeholder />
      <div class="main">
        <el-button type="text" icon="el-icon-remove-outline" circle @click="cmd0" />

        <span class="qty">{{ Number(qty1) }}</span>

        <el-button type="text" icon="el-icon-circle-plus-outline" circle @click="cmd1" />
      </div>
      <Footer :b1="btnCarText()" :anime="checkInput()" @b1c="cmdStart()" />
    </van-popup>
  </div>
</template>
<style scoped>
.qty {
  font-size: 3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.el-button {
  margin: 0;
  padding: 2rem;
  font-size: 3rem;
  line-height: 3rem;
  color: v-bind(sGetConfig("color2"));
}
.van-button {
  background-color: v-bind(sGetConfig("color3"));
  color: white;
  /* border-radius: 2rem; */
  margin: 0.5%;
  width: 99%;
  /* height: 44px; */
  font-size: 1rem;
  z-index: 2;
}
.van-popup,
.main {
  width: 360px;
  line-height: 2rem;
  text-align: center;
  padding-top: 2rem;
}
.van-field {
  margin-top: 1rem;
}
.container {
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tip {
  position: fixed;
  left: 50%;
  bottom: 0rem;
  transform: translate(-50%, -50%);
}
.van-image {
  padding: 0;
  margin: 0;
}
</style>
<script>
var fits = require("../../../mixin/lib-fits-front");
export default {
  data() {
    return {
      visible: false,
      anime: true,
      phone: "",
      showKB: false,
      qty1: 0,
    };
  },
  mounted() {
    try {
      let custTotal = fits.val(this.sOrderH.CustTotal);
      this.qty1 = custTotal;
    } catch (error) {
      this.qty1 = 0;
    }
  },
  methods: {
    isEatIn() {
      let tblid = fits.str(this.$route.query.tblid);
      if (tblid != "") return true;
      return false;
    },
    isZero() {
      if (this.qty1 < 1) {
        return true;
      }
      return false;
    },
    cmd0() {
      this.qty1--;
      if (this.qty1 < 1) this.qty1 = 1;
      // this.onChange();
    },
    cmd1() {
      this.qty1++;
      if (this.qty1 > 12) this.qty1 = 12;
      // this.onChange();
    },
    async cmdStart() {
      // if (!this.checkInput()) return false;
      // // 1.使用者/用餐方式
      // this.$store.commit("setUser", this.phone);
      // if (!this.sGetConfig("kioskMode")) {
      //   sessionStorage.setItem("phone", this.phone);
      // }

      // console.log("s.uid", this.uid);
      this.$store.state.sCustCount = this.qty1;
      this.visible = false;
      // await this.gLoadOrdertmp();
    },

    async show() {
      // var phone = this.gStr(sessionStorage.getItem("phone"));
      // if (this.sGetConfig("kioskMode")) phone = "";
      // phone != "" && (this.phone = phone);
      this.visible = true;
    },

    checkInput() {
      if (this.qty1 < 1) {
        return false;
      }

      return true;
    },
    btnCarText() {
      if (this.qty1 > 0) {
        return "客數 " + this.qty1 + " 位";
      }

      return "請輸入來客數";
    },
  },
};
</script>
